module.exports = __webpack_public_path__ + "img/img54.4b9389e2.jpg";